import { Component } from '@angular/core';

import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PlanService } from 'src/app/service/plan.service';
import { DialogComponent } from './../../core/dialog/dialog.component';

@Component({
    selector: 'app-plan',
    templateUrl: './plan.component.html',
    styleUrls: ['./plan.component.scss'],
    standalone: false // NOSONAR
})
export class PlanComponent {


  pipe: DatePipe;
  routeRun: string = "";
  routeDate: Date | undefined;
  javaRouteDate: string | null;
  enableError: boolean = false;
  enableSubmit: boolean = false;
  routeRunErrorMsg: string = "";
  routeDateErrorMsg: string = "";
  truckTypes: { trailerTypeId: number, truck: string, trailerType: string }[] = [];
  truckTypesTemp: any = [];
  truckTypeChoosen: { trailerTypeId: number, truck: string, trailerType: string } | null = null;

  ngOnInit(): void { // NOSONAR
    this.pipe = new DatePipe('en-US');
    this.truckTypesTemp = localStorage.getItem('Truck-Types');
    this.truckTypes = JSON.parse(this.truckTypesTemp);
    this.truckTypeChoosen = this.truckTypes[0];
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.trailerTypeId == o2.trailerTypeId : o1 == o2;  // NOSONAR
  }

  constructor(private readonly planService: PlanService, private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly dialog: MatDialog) { }

  public OnDateChange(event): void {
    this.routeDate = event;
    this.validateInput();
  }

  validateInput() {
    const routeRunPattern = /^[A-Z]{3,4}\d?-\d{2}$/; // Regex for allowed formats

    if (!this.routeRun || this.routeRun.trim() == '') { // NOSONAR
      this.routeRunErrorMsg = 'Enter Route Run';
    } else if (!routeRunPattern.test(this.routeRun)) {
      this.routeRunErrorMsg = 'Allowed formats: ABCD-01, ABC-10, ABC3-03.';
    } else {
      this.routeRunErrorMsg = '';
    }

    if (this.routeDate == null || this.routeDate == undefined) { // NOSONAR
      this.routeDateErrorMsg = 'Enter Route Date';
    } else {
      this.routeDateErrorMsg = '';
    }
    console.info(this.routeDateErrorMsg + "RouteDateError");


    this.enableError = this.routeRunErrorMsg !=  "" || this.routeDateErrorMsg !=  ""; // NOSONAR
    this.enableSubmit = !this.enableError;
  }

  openDialog(data: { message: string; pdfLinks: any; errorExists: any }): void {
    this.dialog.open(DialogComponent, {
      data,
      width: '600px', // Adjust width if necessary
    });
  }

  view() {
    console.info("Route Run: " + this.routeRun);
    console.info("Route Date: " + this.routeDate);
    const userInfo = localStorage.getItem('user-info');
    const userDetails = userInfo ? JSON.parse(userInfo) : [];

    const obj = {
      "MANIFEST_ID": undefined, "ERROR_CODE": undefined, "ERROR_DESCRIPTION": undefined, "ORGID": undefined,
      "PDF_URL": undefined
    };
    this.ngxUiLoaderService.start("loader-01");

    this.javaRouteDate = this.pipe.transform(this.routeDate, 'dd-MMM-yyyy');

    const requestData = {
      "puroute": this.routeRun,
      "routeDate": this.javaRouteDate,
      "trailerId": this.truckTypeChoosen?.trailerTypeId,
      "truck": this.truckTypeChoosen?.trailerType,
      "userDetails": userDetails
    };


    this.planService.getPlanData(requestData).subscribe(result => {

      console.info("API Response:", result);

      const data = result?.MLP_OPTIMIZE_LOAD;

      if (Array.isArray(data) && data.length > 0) {
        const pdfLinks = data.map(item => ({
          PDF_URL: item?.PDF_URL?.trim(),
          ERROR_DESCRIPTION: item?.ERROR_DESCRIPTION?.trim(),
        })).filter(item => item.PDF_URL);

        const errorExists = data.filter(item => item?.ERROR_CODE !=  "0"); // NOSONAR

        if (pdfLinks.length > 0) {
          // Display PDF links in the dialog
          this.openDialog({
            message: `PDF links for Supplier Code: ${this.routeRun} and Route Date: ${this.javaRouteDate}:`,
            pdfLinks,
            errorExists: null,
          });
        } else if (errorExists.length > 0) {
          // Display errors in the dialog
          this.openDialog({
            message: `Error(s) for Supplier Code: ${this.routeRun} and Route Date: ${this.javaRouteDate}:`,
            pdfLinks: null,
            errorExists,
          });
        } else {
          // No PDF links or specific errors
          this.openDialog({
            message: `No PDF exists for Supplier Code: ${this.routeRun} and Route Date: ${this.javaRouteDate}.`,
            pdfLinks: null,
            errorExists: null,
          });
        }
      } else {
        // No data received
        this.openDialog({
          message: `No data received from the API for Supplier Code: ${this.routeRun} and Route Date: ${this.javaRouteDate}.`,
          pdfLinks: null,
          errorExists: null,
        });
      }

      this.ngxUiLoaderService.stop("loader-01");
    }, error => {
      console.info("Error fetching supplier data:", error);
      this.openDialog({
        message: `An error occurred while fetching the data for Supplier Code: ${this.routeRun} and Route Date: ${this.javaRouteDate}. Please try again.`,
        pdfLinks: null,
        errorExists: null,
      });
      this.ngxUiLoaderService.stop("loader-01");
    });
    console.info("Object Data" + obj);
  }


}

